import '@/styles/newLP.css'
import '@/styles/tailwind.css'
import '@/styles/footer.css'
import '@/styles/globals.css'
import '@/styles/blockUI.css'
import '@/styles/contact.css'
import '@/styles/interview.css'

import type { AppProps } from 'next/app'

import GoogleAnalytics from '@/components/GoogleAnalytics'
import LpFooter from '@/components/parts/lpPage/LpFooter'

const MyApp = ({ Component, pageProps }: AppProps) => {
  return (
    <>
      {process.env.NEXT_PUBLIC_GA_ID && <GoogleAnalytics gaId={process.env.NEXT_PUBLIC_GA_ID!} />}
      <Component {...pageProps} />
      <LpFooter />
    </>
  )
}

export default MyApp
